<template>
  <div class="date-select" :class="{'disabled': readonly}" @click="openPick">
    <p class="text">{{ $filters.formatDate(itemValue, formatType) || '请选择时间' }}</p>
    <van-icon class="icon" name="arrow-down" />
  </div>
  <van-popup v-model:show="showPicker" position="bottom">
    <van-datetime-picker
      v-model="selectDate"
      :type="dateType"
      title="选择时间"
      @cancel="showPicker = false"
      @confirm="onConfirm($event)"
    />
  </van-popup>
</template>

<script>
import _ from 'lodash';
import { Icon, Popup, DatetimePicker } from 'vant';
import getUnixTime from 'date-fns/getUnixTime';
import fromUnixTime from 'date-fns/fromUnixTime';

export default {
  props: {
    item: Object,
    submitValue: Object,
    readonly: Boolean
  },
  emits: ['change'],
  data() {
    return {
      itemValue: null,
      showPicker: false,
      selectDate: null
    };
  },
  computed: {
    dateType() {
      let type = 'date';
      if (this.item?.date_format === 'day') {
        type = 'date';
      } else if(this.item?.date_format === 'min') {
        type = 'datetime';
      }
      return type;
    },
    formatType() {
      let type = 'yyyy-MM-dd';
      if (this.item?.date_format === 'day') {
        type = 'yyyy-MM-dd';
      } else if(this.item?.date_format === 'min') {
        type = 'yyyy-MM-dd HH:mm';
      }
      return type;
    }
  },
  components: {
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Icon.name]: Icon
  },
  methods: {
    // 【1】itemValue值设置
    setItemValue() {
      this.itemValue = this.submitValue?.value || null;
    },
    // 【2】值监听
    onValueChange() {
      this.$emit('change', {
        value: this.itemValue
      });
    },
    openPick() {
      if (this.readonly) {
        return;
      }
      this.selectDate = this.itemValue ? fromUnixTime(this.itemValue) : new Date();
      this.showPicker = true;
    },
    onConfirm(value, type) {
      this.itemValue = getUnixTime(this.selectDate);
      this.showPicker = false;
      this.onValueChange();
    },
  },
  created() {
    this.setItemValue();
  },
  async mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.date-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .input-item();
  .icon {
    font-size: @font-size-2;
    margin-right: 4px;
    color: var(--theme-main-color);
  }
}
</style>
